import React from 'react';
import { Button } from 'react-bootstrap';
import { connect } from 'react-redux';
import { reduxForm, formValueSelector } from 'redux-form';
import PropTypes from 'prop-types';
import ContractCheckoutValidator from '../../../common/validation/ContractCheckoutValidator';
import NameOnID from '../NameOnID/NameOnID';
import PersonalIdentificationContainer from '../../../redux/containers/PersonalIdentificationContainer';
import AboutYou from '../AboutYou/AboutYou';
import FormTickBoxContainer from '../../../redux/containers/FormTickBoxContainer';
import NextButton from '../NextButton/NextButton';
import handleSubmitFail from '../SubmitFailHandler';
import Configuration from '../../../common/Configuration.json';
import CheckoutFormInitialValues from '../Checkout/CheckoutFormInitialValues';
import { CheckoutSelector } from '../../../redux/reducers/CheckoutReducer';

class CreditAssessmentStep1 extends React.Component {

  componentDidMount() {
    if (this.props.caError) {
      const identitySection = document.getElementById('identity-section');
      identitySection.scrollIntoView();
    }
  }

  render() {
    const {
      hasAgreedToCreditAssessment, connectionFee, modemPrice,
      handleSubmit, handleNext, handleSwitchToOpenTerm, caError
    } = this.props;
    return (
      <section>
        <form onSubmit={handleSubmit(handleNext)}>
          <AboutYou />
          <div className="container">
            <div className="row">
              <div className="col-xs-12">
                <h3 className="half-charcoal">Credit assessment information</h3>
                <p>
                  We need your email address and a few more details from you.
                  Because it&apos;s a new account we need to run a standard credit assessment, so please answer
                  the questions as accurately as you can.
                  We always respect the use of your personal information which is held in accordance
                  with our <a
                    href="https://www.skinny.co.nz/skinny-terms/disclosure"
                    rel="noopener noreferrer"
                    target="_blank"
                  >Disclosure</a>.
                </p>
                <FormTickBoxContainer
                  autotestClass="autotest-has-agreed-to-credit-assessment"
                  id="has-agreed-to-credit-assessment"
                  name="creditAssessment.agreeToCreditAssessment"
                  required
                >
                  I agree to a credit assessment
                </FormTickBoxContainer>
              </div>
            </div>

            {!hasAgreedToCreditAssessment &&
            <div className="row">
              <div className="col-xs-12">
                <p>
                  If you would rather not go through a credit assessment, you can still sign up with us on a No Pesky
                  Terms contract (please note a one-off ${modemPrice} modem purchase may apply and a ${connectionFee} connection fee will
                  apply on a No Pesky Term contract).
                </p>
                <p>
                  <Button
                    id="switch-to-no-pesky-term-button"
                    type="button"
                    className="btn btn-default btn-secondary"
                    onClick={handleSwitchToOpenTerm}
                  >
                    SWITCH TO NO PESKY TERM
                  </Button>
                </p>
              </div>
            </div>
            }
          </div>
          <div id="identity-section" />
          {hasAgreedToCreditAssessment &&
          <div>
            <NameOnID caError={caError} />
            <PersonalIdentificationContainer caError={caError} />
            <NextButton />
          </div>
          }
        </form>
      </section>
    );
  }
}

const formSelector = formValueSelector('checkout');
const mapStateToProps = state => ({
  hasAgreedToCreditAssessment: formSelector(state, 'creditAssessment.agreeToCreditAssessment'),
  connectionFee: Configuration.connectionFee,
  modemPrice: Configuration.modemPrice,
  caError: CheckoutSelector.getCaError(state)
});

CreditAssessmentStep1.propTypes = {
  hasAgreedToCreditAssessment: PropTypes.bool,
  connectionFee: PropTypes.number,
  modemPrice: PropTypes.number,
  handleSubmit: PropTypes.func,
  handleNext: PropTypes.func,
  handleSwitchToOpenTerm: PropTypes.func,
  caError: PropTypes.object
};

export default connect(mapStateToProps)(reduxForm({
  form: 'checkout', // Form name is same
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,  // Unregister fields on unmount
  validate: ContractCheckoutValidator,
  initialValues: CheckoutFormInitialValues,
  onSubmitFail: err => handleSubmitFail(err)
})(CreditAssessmentStep1));



/** WEBPACK FOOTER **
 ** ./src/components/checkout/CreditAssessmentStep1/CreditAssessmentStep1.js
 **/